import React from 'react';
import { Button, Text, VStack } from '@chakra-ui/react';
import {
  IPTV_PANEL_INVALID_AUTH,
  IPTV_PANEL_INVALID_URL,
  IPTV_PANEL_NETWORK_OR_UNREACHABLE,
  IPTV_PANEL_UNKNOWN,
} from '../utils/iptvPanelErrors';

interface Props {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}

/** Short heading for load / connection errors (e.g. dialog title). */
export function catalogLoadErrorTitle(message: string): string {
  if (message.includes(IPTV_PANEL_INVALID_AUTH)) return 'Invalid credentials';
  if (message.includes(IPTV_PANEL_INVALID_URL)) return 'Invalid panel URL';
  if (message.includes(IPTV_PANEL_NETWORK_OR_UNREACHABLE)) {
    return 'Cannot connect to IPTV panel';
  }
  if (message.includes(IPTV_PANEL_UNKNOWN)) {
    return 'IPTV panel error';
  }
  if (
    message.includes('Xtream panel') ||
    message.includes('CORS') ||
    message.includes('Provider blocked browser access')
  ) {
    return 'Cannot connect to IPTV panel';
  }
  return 'Something went wrong';
}

export function ErrorState({
  title,
  message,
  onRetry,
  retryLabel = 'Try again',
}: Props) {
  const resolvedTitle = title ?? catalogLoadErrorTitle(message);
  return (
    <VStack spacing={4} py={10} px={6} align="stretch" maxW="lg" mx="auto">
      <Text fontSize="md" fontWeight="600" color="red.300">
        {resolvedTitle}
      </Text>
      <Text fontSize="sm" color="whiteAlpha.700" whiteSpace="pre-wrap">
        {message}
      </Text>
      {onRetry && (
        <Button size="sm" colorScheme="teal" variant="solid" onClick={onRetry} alignSelf="flex-start">
          {retryLabel}
        </Button>
      )}
    </VStack>
  );
}
